import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SundryFactoryManualChecklistReport } from './Pages';

export const SundryFactoryManualChecklistReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={SundryFactoryManualChecklistReport} />

    </Fragment>
)